{
  "admins": {
    "errors": {
      "add": "添加管理员失败。",
      "notFound": "找不到该管理员。"
    }
  },
  "home": {
    "goToSandbox": "前往沙盒",
    "subtitle": "这个仓库是使用 React、shadcn-ui 和 TanStack Router 构建 Web 应用程序的起点。",
    "title": "欢迎使用 Mindsea React 模板。"
  },
  "login": {
    "errors": {
      "invalidEmail": "请输入有效的电子邮件地址。",
      "unauthorized": "您无权访问此应用程序。"
    },
    "placeholder": "name@example.com",
    "sendCode": "发送验证码",
    "subtitle": "在此构建登录页面。",
    "title": "登录"
  }
}
